import React from 'react';
import { Lead } from '../../types/lead';
import { UploadCloud, FileText } from 'lucide-react';
interface LeadFieldsPanelProps {
  lead: Lead;
  onChange: (field: keyof Lead, value: any) => void;
}
export function LeadFieldsPanel({
  lead,
  onChange
}: LeadFieldsPanelProps) {
  return <div className="space-y-6" data-id="element-335">
      <div className="card p-6" data-id="element-336">
        <div className="flex items-center mb-6 border-b border-white/5 pb-4" data-id="element-337">
          <div className="w-8 h-8 rounded-lg bg-growthly-amber/10 flex items-center justify-center mr-3" data-id="element-338">
            <FileText className="w-4 h-4 text-growthly-amber" data-id="element-339" />
          </div>
          <div data-id="element-340">
            <h3 className="text-[16px] font-semibold text-growthly-text" data-id="element-341">
              Estado Digital del Negocio
            </h3>
            <p className="text-[12px] text-growthly-muted mt-0.5" data-id="element-342">
              Información sobre la presencia online actual
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5" data-id="element-343">
          <div data-id="element-344">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-345">
              Estado Web
            </label>
            <select value={lead.ESTADO_WEB_MENU} onChange={e => onChange('ESTADO_WEB_MENU', e.target.value)} className="input-field bg-growthly-bg" data-id="element-346">
              <option value="No web" data-id="element-347">No web</option>
              <option value="Web obsoleta" data-id="element-348">Web obsoleta</option>
              <option value="Web funcional" data-id="element-349">Web funcional</option>
            </select>
          </div>
          <div data-id="element-350">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-351">
              Estado Menú
            </label>
            <select value={lead.MENU_STATUS} onChange={e => onChange('MENU_STATUS', e.target.value)} className="input-field bg-growthly-bg" data-id="element-352">
              <option value="Papel" data-id="element-353">Papel</option>
              <option value="PDF" data-id="element-354">PDF</option>
              <option value="Digital" data-id="element-355">Digital</option>
            </select>
          </div>
        </div>

        <div data-id="element-356">
          <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-357">
            Nota de Carencia (Identificación de necesidad)
          </label>
          <input type="text" value={lead.NOTA_CARENCIA || ''} onChange={e => onChange('NOTA_CARENCIA', e.target.value)} placeholder="Ej: Menú sucio, web no carga en móvil..." className="input-field bg-growthly-bg" data-id="element-358" />
        </div>
      </div>

      <div className="card p-6" data-id="element-359">
        <div className="flex items-center mb-6 border-b border-white/5 pb-4" data-id="element-360">
          <div className="w-8 h-8 rounded-lg bg-growthly-green/10 flex items-center justify-center mr-3" data-id="element-361">
            <UploadCloud className="w-4 h-4 text-growthly-green" data-id="element-362" />
          </div>
          <div data-id="element-363">
            <h3 className="text-[16px] font-semibold text-growthly-text" data-id="element-364">
              Evidencia y Micro-acción
            </h3>
            <p className="text-[12px] text-growthly-muted mt-0.5" data-id="element-365">
              Registro de interés y próximos pasos
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5" data-id="element-366">
          <div data-id="element-367">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-368">
              Tipo
            </label>
            <select value={lead.MICRO_ACCION_TYPE || ''} onChange={e => onChange('MICRO_ACCION_TYPE', e.target.value)} className="input-field bg-growthly-bg" data-id="element-369">
              <option value="" data-id="element-370">Seleccionar...</option>
              <option value="Demo" data-id="element-371">Demo</option>
              <option value="Propuesta" data-id="element-372">Propuesta</option>
              <option value="Cita" data-id="element-373">Cita</option>
              <option value="Otro" data-id="element-374">Otro</option>
            </select>
          </div>
          <div data-id="element-375">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-376">
              Fecha
            </label>
            <input type="datetime-local" value={lead.MICRO_ACCION_DATE ? lead.MICRO_ACCION_DATE.substring(0, 16) : ''} onChange={e => onChange('MICRO_ACCION_DATE', e.target.value)} className="input-field bg-growthly-bg" data-id="element-377" />
          </div>
          <div data-id="element-378">
            <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-379">
              Canal
            </label>
            <select value={lead.CANAL_CONFIRMACION || ''} onChange={e => onChange('CANAL_CONFIRMACION', e.target.value)} className="input-field bg-growthly-bg" data-id="element-380">
              <option value="" data-id="element-381">Seleccionar...</option>
              <option value="WhatsApp" data-id="element-382">WhatsApp</option>
              <option value="Email" data-id="element-383">Email</option>
              <option value="Teléfono" data-id="element-384">Teléfono</option>
              <option value="DM" data-id="element-385">DM</option>
            </select>
          </div>
        </div>

        <div className="mb-5" data-id="element-386">
          <label className="block text-[12px] font-medium text-growthly-muted mb-1.5" data-id="element-387">
            Texto Evidencia (Copia exacta)
          </label>
          <textarea value={lead.TEXTO_EVIDENCIA || ''} onChange={e => onChange('TEXTO_EVIDENCIA', e.target.value)} rows={3} placeholder="Pega aquí la respuesta exacta del decisor..." className="input-field resize-none bg-growthly-bg" data-id="element-388" />
        </div>

        <div data-id="element-389">
          <label className="block text-[12px] font-medium text-growthly-muted mb-2" data-id="element-390">
            Adjuntos (Capturas, audios)
          </label>
          <div className="border-2 border-dashed border-white/10 rounded-xl p-6 text-center hover:bg-white/5 transition-colors cursor-pointer bg-growthly-bg" data-id="element-391">
            <UploadCloud className="w-8 h-8 text-growthly-muted mx-auto mb-3" data-id="element-392" />
            <p className="text-[14px] text-growthly-text font-medium" data-id="element-393">
              Click para subir o arrastra archivos
            </p>
            <p className="text-[12px] text-growthly-muted mt-1.5" data-id="element-394">
              Soporta imágenes, PDF, MP3 (Max 10MB)
            </p>
          </div>

          {lead.EVIDENCE_ATTACHMENTS && lead.EVIDENCE_ATTACHMENTS.length > 0 && <div className="mt-4 space-y-2" data-id="element-395">
                {lead.EVIDENCE_ATTACHMENTS.map(att => <div key={att.id} className="flex items-center justify-between p-3 border border-white/5 rounded-lg bg-white/5" data-id="element-396">
                    <div className="flex items-center" data-id="element-397">
                      <FileText className="w-4 h-4 text-growthly-muted mr-3" data-id="element-398" />
                      <span className="text-[13px] font-medium text-growthly-text" data-id="element-399">
                        {att.filename}
                      </span>
                    </div>
                    <button className="text-[12px] font-medium text-growthly-red hover:text-growthly-red/80 transition-colors" data-id="element-400">
                      Eliminar
                    </button>
                  </div>)}
              </div>}
        </div>
      </div>
    </div>;
}